import axios from "axios";
import cookie from "vue-cookies";

axios.defaults.params = {};
axios.defaults.params.token = process.env.VUE_APP_API_TOKEN;
axios.defaults.params.hash = cookie.get("hash");

export default {
  updateHash() {
    axios.defaults.params.hash = cookie.get("hash");
  },

  endpoint(uri) {
    if (uri.substring(0, 1) == "/") {
      uri = uri.substring(1, uri.length);
    }

    this.updateHash();

    let api_url = process.env.VUE_APP_API_URL;

    if (process.env.VUE_APP_PRODUCTION_MODE === "true") {
      const prod_urls = [
        process.env.VUE_APP_PROD_API_URL_1,
        process.env.VUE_APP_PROD_API_URL_2,
      ];

      api_url = prod_urls[Math.floor(Math.random() * prod_urls.length)];
    }

    return api_url + process.env.VUE_APP_API_VERSION + "/" + uri;
  },

  get(uri, params = {}) {
    return axios.get(this.endpoint(uri), {
      params: params,
      withCredentials: true,
    });
  },

  post(uri, params = {}) {
    return axios.post(this.endpoint(uri), params);
  },

  put(uri, params = {}) {
    return axios.put(this.endpoint(uri), params);
  },

  patch(uri, params = {}) {
    return axios.patch(this.endpoint(uri), params);
  },

  delete(uri, params = {}) {
    return axios.delete(this.endpoint(uri), params);
  },
};
